import {
	Button,
	ExpansionPanel,
	ExpansionPanelDetails,
	ExpansionPanelSummary,
	Grid,
	List,
	ListItem,
	SwipeableDrawer,
	TextField,
	Typography
} from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { imageLocation } from '../config/constants';
import { flatten, intersection, keys, uniq } from 'lodash';
import React, { Component } from 'react';
import '../style/samples.css';
import { MobileProjectDialog, ProjectDialog } from './projectDialog';
import Checkbox from 'react-simple-checkbox';

export class Samples extends Component {
	state = {
		open: false,
		fading: 'in',
		filter: {},
        search: null,
        tagsOpen: true
	};

    wordColor = 'orange'
	componentWillMount() {
		document.title = 'Search';
	}

	clicked(key, value) {
		var newstate = { filter: this.state && this.state.filter ? this.state.filter : {} };
		if (!newstate.filter[key]) newstate.filter[key] = [];
		var index = newstate.filter[key].indexOf(value);
		if (index > -1) {
			newstate.filter[key].splice(index, 1);
			if (newstate.filter[key].length === 0) delete newstate.filter[key];
		} else newstate.filter[key].push(value);
		this.setState(newstate);
	}

	setImage(currentImage) {
		this.setState({ fading: 'in', currentImage });
	}

	expand(key) {
		var newstate = {};
		newstate[key] = this.state && this.state[key] ? !this.state[key] : true;
		this.setState(newstate);
	}

	keyPressed(event) {
		this.search = event.target.value;
	}

	getTypes() {
		return (
			<div>
				<ExpansionPanel style={{ backgroundColor: 'transparent' }}>
					<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
						<Typography style={{ color: this.wordColor, fontSize: '110%'}}>type</Typography>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails style={{ padding: 0 }}>
						<List>
							<ListItem dense style={{ padding: 0 }}>
								<Checkbox
									style={{ width: 30, height: 30 }}
									checked={
										this.state.filter.type && this.state.filter.type.includes('residential') ? (
											true
										) : (
											false
										)
									}
									onChange={() => this.clicked('type', 'residential')}
									type="checkbox"
								/>
								<Typography style={{ color: this.wordColor, paddingTop: '10px' }}>residential</Typography>
							</ListItem>
							<ListItem dense style={{ padding: 0 }}>
								<Checkbox
									style={{ width: 30, height: 30 }}
									checked={
										this.state.filter.type && this.state.filter.type.includes('commercial') ? (
											true
										) : (
											false
										)
									}
									onChange={() => this.clicked('type', 'commercial')}
									type="checkbox"
								/>
								<Typography style={{ color: this.wordColor, paddingTop: '10px' }}>commercial</Typography>
							</ListItem>
						</List>
					</ExpansionPanelDetails>
				</ExpansionPanel>
			</div>
		);
	}

	render() {
		return (
			<div className="samples">
				<ProjectDialog
					setImage={(name) => this.setImage(name)}
					fadeOut={() => this.setState({ fading: 'out' })}
					close={() => this.setState({ open: false })}
					open={this.state.open}
					project={this.state.project}
					fade={this.state.fading}
					image={this.state.currentImage}
				/>
				<Grid container spacing={16} className='sidebar' >
					<Grid item xs={2}>
						{this.getTags()}
						{this.getOptions('projects', 'location', 'location')}
						{this.getOptions('projects', 'year', 'date')}
						{this.getOptions('projects', 'project', 'name')}
						{this.getTypes()}
						<TextField
							className="full-width"
							onChange={(event) => this.keyPressed(event)}
							type="text"
							placeholder="search tags"
						/>
						<Button
							onClick={() =>
								this.search !== ''
									? this.setState({ search: this.search })
									: this.setState({ search: null })}
						>
							<Typography style={{color:'orange'}}> search </Typography>
						</Button>
					</Grid>
					<Grid item xs={10}>
						<div className="filterNames">
							{this.state.search && (
								<div style={{ float: 'left' }}>
									<p>{'search: ' + this.state.search}</p>
									<Close onClick={() => this.setState({ search: null })} />
								</div>
							)}
							{this.state &&
								this.state.filter &&
								Object.keys(this.state.filter).map(
									(key, idx) =>
										this.state.filter[key].length ? (
											<div key={'filter' + idx}>
												<p className="keyName">{key + ': '}</p>
												{this.state.filter[key].map((value, idx) => (
													<div style={{ float: 'left' }}>
														<p key={'value' + idx}> {value + ''} </p>
														<Close
															onClick={() =>
																this.setState({
																	filter: {
																		...this.state.filter,
																		[key]: this.state.filter[key].filter(
																			(val) => val !== value
																		)
																	}
																})}
														/>
													</div>
												))}
											</div>
										) : null
								)}
						</div>
						{this.filterImages().map((image, idx) => (
							<div
								className="image"
								style={{
									backgroundImage: `url(${imageLocation}projects/${image.name.replace(/ /g, '%20')})`
								}}
								onClick={() =>
									this.setState({
										open: true,
										currentImage: image.name.replace(/ /g, '%20'),
										project: this.props.data.projects.filter(
											(project) => project.name === image.project
										)[0]
									})}
							/>
						))}
					</Grid>
				</Grid>
			</div>
		);
	}

	filterImages() {
		return flatten(
			this.props.data.projects
				.filter((project) => this.checkProjectFilter(project, this.state ? this.state.filter : null))
				.sort((a, b) => String(a['name']).localeCompare(String(b['name'])))
				.map((project) =>
					project.images.map((image) => {
						image['project'] = project.name;
						return image;
					})
				)
		).filter((image) => {
			var include = false;
			if (this.state && this.state.search) {
				for (var imgTag in image.tags) {
					let temp = image.tags[imgTag].Name;
					if (temp.toLowerCase().includes(this.state.search.toLowerCase())) {
						include = true;
						break;
					}
				}
			} else include = true;
			if (this.state && this.state.filter && this.state.filter['tags']) {
				var int = this.state.filter['tags'].map((tag) => tag.toLowerCase()).filter((tag) => {
					return (
						image.tags.map((tag) => tag.Name.toLowerCase()).filter((name) => name.includes(tag)).length > 0
					);
				});
				if (int.length !== this.state.filter['tags'].length) return false;
			}
			return include;
		});
	}

	checkProjectFilter(project, filter) {
		return (
			!filter ||
			((!filter['year'] ||
				filter['year'].length === 0 ||
				intersection(filter['year'], [ project.date ]).length > 0) &&
				(!filter['project'] ||
					filter['project'].length === 0 ||
					intersection(filter['project'], [ project.name ]).length > 0) &&
				(!filter['location'] ||
					filter['location'].length === 0 ||
					intersection(filter['location'], [ project.location ]).length > 0) &&
				(!filter['type'] ||
					filter['type'].length === 0 ||
					intersection(filter['type'].map((f) => f.toLowerCase()), [ project.type ]).length > 0))
		);
	}

	getOptions(category, key, attribute) {
		return (
			<div>
				<ExpansionPanel style={{ backgroundColor: 'transparent' }}>
					<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
						<Typography style={{ color: this.wordColor, fontSize: '110%'}}>{key}</Typography>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails style={{ padding: 0 }}>
						<List>
							{uniq(this.props.data[category].map((thing) => thing[attribute]))
								.sort()
								.map((option, idx) => (
									<ListItem dense style={{ padding: 0 }} key={attribute + idx}>
										<Checkbox
											style={{ width: 25, height: 25 }}
											checked={
												this.state.filter[key] && this.state.filter[key].includes(option) ? (
													true
												) : (
													false
												)
											}
											onChange={() => this.clicked(key, option)}
											type="checkbox"
										/>
										<Typography style={{ color: this.wordColor, paddingTop: '10px' }}> {option} </Typography>
									</ListItem>
								))}
						</List>
					</ExpansionPanelDetails>
				</ExpansionPanel>
			</div>
		);
	}

	getTags() {
        this.tagsOpen = true
		return (
			<div>
                <ExpansionPanel 
                    fill='black'
                    expanded={this.state.tagsOpen} onChange={() => this.setState({tagsOpen:!this.state.tagsOpen})}
                        style={{ backgroundColor: 'transparent', color: this.wordColor }}>
					<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
						<Typography style={{ color: this.wordColor, fontSize: '110%'}}>tags</Typography>
					</ExpansionPanelSummary>
					<List>
						{this.props.data.commonTags.sort().map((tag, idx) => (
							<ListItem dense style={{ padding: 0 }} key={'tag' + idx}>
								<Checkbox
                                    color={{tickColor: '#ffa500'}}
									checked={
										this.state.filter.tags && this.state.filter.tags.includes(tag) ? true : false
									}
									onChange={() => this.clicked('tags', tag)}
									type="checkbox"
									style={{ width: 30, height: 30 }}
								/>
								<Typography style={{ color: this.wordColor, paddingTop: '10px' }}>{tag}</Typography>
							</ListItem>
						))}
					</List>
				</ExpansionPanel>
			</div>
		);
	}
}

export class MobileSamples extends Samples {
	state = {
		open: false,
		fading: 'in',
		filter: {},
		search: null,
		drawerOpen: false
	};
	render() {
		return (
			<div className="mobileSamples">
				<Button
					style={{ width: '10%', position: 'sticky', top: '0', color: '#DCDCDC' }}
					onClick={() => this.setState({ drawerOpen: !this.state.drawerOpen })}
					size="small"
				>
					Filters
				</Button>
				<MobileProjectDialog
					setImage={(name) => this.setImage(name)}
					fadeOut={() => this.setState({ fading: 'out' })}
					close={() => this.setState({ open: false })}
					open={this.state.open}
					project={this.state.project}
					fade={this.state.fading}
					image={this.state.currentImage}
				/>
				<div>
					<SwipeableDrawer
						style={{ opacity: '.80', color: 'black' }}
						PaperProps={{ style: { width: '50%', backgroundColor: 'rgb(37,37,37)' } }}
						open={this.state.drawerOpen}
						onOpen={() => this.setState({ drawerOpen: true })}
						onClose={() => this.setState({ drawerOpen: false })}
					>
						<div>
							{this.getOptions('projects', 'Location', 'location')}
							{this.getOptions('projects', 'year', 'date')}
							{this.getOptions('projects', 'project', 'name')}
							{this.getTags()}
							{this.getTypes()}
						</div>
					</SwipeableDrawer>
				</div>
				{this.state && this.state.filter && keys(this.state.filter).length ? (
					<div className="filterNames">
						{this.state && this.state.search && <p> {'search: ' + this.state.search} </p>}
						{this.state &&
							this.state.filter &&
							Object.keys(this.state.filter).map(
								(key, idx) =>
									this.state.filter[key].length ? (
										<div key={'filter' + idx}>
											<p className="keyName">{key + ': '}</p>
											{this.state.filter[key].map((value, idx) => (
												<p key={'value' + idx}>
													{value}
													<Close
														style={{ fontSize: '1em' }}
														onClick={() =>
															this.setState({
																filter: {
																	...this.state.filter,
																	[key]: this.state.filter[key].filter(
																		(val) => val !== value
																	)
																}
															})}
													/>{' '}
												</p>
											))}
										</div>
									) : (
										<div />
									)
							)}
					</div>
				) : null}
				{this.filterImages().map((image, idx) => (
					<div
						className="image"
						key={'image' + idx}
						style={{
							backgroundImage: `url(${imageLocation}projects/${image.name.replace(/ /g, '%20')})`,
							marginLeft: '5px'
						}}
						onClick={() =>
							this.setState({
								open: true,
								currentImage: image.name.replace(/ /g, '%20'),
								project: this.props.data.projects.filter((project) => project.name === image.project)[0]
							})}
					/>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/samples.js